import { useEffect } from 'react';
import { useAppSelector, shallowEqual } from 'store/hook';
import { createWebSocket } from 'utils/task/socket';

const Websocket = () => {
  const userId = useAppSelector(({ user }) => user.user?.account?.userId, shallowEqual);
  useEffect(() => {
    if (userId) {
      createWebSocket(userId);
    }
  }, [userId]);
  return null;
};

export default Websocket;
